module.exports = __webpack_public_path__ + "static/media/mazda-logo-white.90bc02a7.svg";